import { Alert, ErrorIcon } from "@fluentui/react-northstar";
import { TeamInfoDTO } from "@teams/types/api";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";

import { useNps } from "../../../_shared/actions/useNps";
import { useUserInfo } from "../../../_shared/actions/useUserInfo";
import { TeamsLoader } from "../../../_shared/components/TeamsLoader";
import { channelApi, isError } from "../../../_shared/services/ChannelApi";
import { useTeamsContext } from "../../../_shared/state/TeamsContextProvider";
import { clientEventTracker } from "../../../_shared/utils/clientTelemetry";
import { MeetingContentPage } from "./MeetingContentPage";
import { MeetingSidePanelPage } from "./MeetingSidePanelPage";

export const MeetingsTabPage: React.FC = () => {
  const { teamsContext } = useTeamsContext();
  const { user } = useUserInfo();
  const [teamInfo, setTeamInfo] = useState<TeamInfoDTO>();
  const [loadError, setLoadError] = useState<Error>();
  const { loadNpsSurveyIfEligible } = useNps("meeting");
  const history = useHistory();

  const loadMeetingRole = useCallback(async () => {
    setLoadError(undefined);
    const teamInfoResponse = await channelApi.getTeamInfo(teamsContext, undefined, true);

    if (!isError(teamInfoResponse)) {
      setTeamInfo(teamInfoResponse);
    } else {
      console.error(teamInfo);
      setLoadError(teamInfoResponse);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadMeetingRole();
    clientEventTracker.track("tab page viewed", user, {
      pageName:
        teamsContext.page.frameContext === "sidePanel" ? "meeting-sidepanel" : "meeting-tab",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadNpsSurveyIfEligible();
  }, [loadNpsSurveyIfEligible]);

  // For Polly tab added in a group chat meeting, we need to show the team tab UI outside the meeting
  // Navigate to the team tab page in this case
  if (!teamsContext.meeting?.id && teamsContext.page.frameContext !== "sidePanel") {
    history.push("/msteams/content/tab/team");
  }

  return (
    <TeamsLoader
      isLoading={!teamInfo && !loadError}
      loadingMessage="Loading Meeting Information..."
    >
      {loadError && (
        <Alert danger content={`Error loading meeting information`} icon={<ErrorIcon />} />
      )}
      {teamInfo && (
        <>
          {teamsContext.page.frameContext === "sidePanel" && (
            <MeetingSidePanelPage teamInfo={teamInfo} />
          )}
          {teamsContext.page.frameContext !== "sidePanel" && (
            <MeetingContentPage teamInfo={teamInfo} />
          )}
        </>
      )}
    </TeamsLoader>
  );
};
